import { AppLanguage } from "../context/LanguageContext";

type LocalizedLabel = Record<AppLanguage, string>;

const ROUTE_LABELS: Record<string, LocalizedLabel> = {
  "/": { "pt-BR": "Comércio", en: "Commerce", es: "Comercio" },
  "/profile": { "pt-BR": "Perfil", en: "Profile", es: "Perfil" },
  "/calendar": { "pt-BR": "Calendário", en: "Calendar", es: "Calendario" },
  "/users": { "pt-BR": "Usuários", en: "Users", es: "Usuarios" },
  "/roles": { "pt-BR": "Perfis", en: "Roles", es: "Perfiles" },
  "/form-elements": {
    "pt-BR": "Elementos de formulário",
    en: "Form Elements",
    es: "Elementos de formulario",
  },
  "/basic-tables": {
    "pt-BR": "Tabelas básicas",
    en: "Basic Tables",
    es: "Tablas básicas",
  },
  "/404": { "pt-BR": "Erro 404", en: "404 Error", es: "Error 404" },
  "/blank": { "pt-BR": "Página em branco", en: "Blank Page", es: "Página en blanco" },
  "/line-chart": { "pt-BR": "Gráfico de linhas", en: "Line Chart", es: "Gráfico de líneas" },
  "/bar-chart": { "pt-BR": "Gráfico de barras", en: "Bar Chart", es: "Gráfico de barras" },
  "/alerts": { "pt-BR": "Alertas", en: "Alerts", es: "Alertas" },
  "/avatars": { "pt-BR": "Avatares", en: "Avatars", es: "Avatares" },
  "/badges": { "pt-BR": "Selos", en: "Badges", es: "Insignias" },
  "/buttons": { "pt-BR": "Botões", en: "Buttons", es: "Botones" },
  "/images": { "pt-BR": "Imagens", en: "Images", es: "Imágenes" },
  "/videos": { "pt-BR": "Vídeos", en: "Videos", es: "Videos" },
  "/signin": { "pt-BR": "Entrar", en: "Sign In", es: "Iniciar sesión" },
  "/signup": { "pt-BR": "Cadastrar", en: "Sign Up", es: "Registrarse" },
  "/activate": { "pt-BR": "Ativar conta", en: "Activate Account", es: "Activar cuenta" },
  "/account-settings": {
    "pt-BR": "Configurações da conta",
    en: "Account settings",
    es: "Configuración de la cuenta",
  },
};

function cleanFallbackTitle(title: string): string {
  return title.split("|")[0].trim();
}

export function getRouteLabel(pathname: string, language: AppLanguage): string | null {
  const localized = ROUTE_LABELS[pathname];
  if (!localized) return null;
  return localized[language];
}

export function getLocalizedPageTitle(
  pathname: string,
  language: AppLanguage,
  fallbackTitle: string
): string {
  return getRouteLabel(pathname, language) ?? cleanFallbackTitle(fallbackTitle);
}
